import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  token: null,
  user: null,
  allClients: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    //get all clients
    getAllClientsStart(state) {
       state.loading = true;
      state.error = null;
    },

    getAllClientsSucess(state, action) {
      state.allClients = action.payload;
          state.loading = false;
    },
    getAllClientsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    //Login Vendor or Admin
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    loginFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    //changed password
    ChangePasswordStart(state) {
      state.loading = true;
      state.error = null;
    },
     ChangePasswordSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
     ChangePasswordFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    //Register Vendor Self
    VendorRegSlefStart(state) {
      state.loading = true;
      state.error = null;
    },
    VendorRegSlefSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    VendorRegSlefFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    logout(state) {
      state.user = null;
      state.token = null;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  VendorRegSlefStart,
  VendorRegSlefSuccess,
  VendorRegSlefFailure,
  logout,
  clearError,
  getAllClientsSucess,
  getAllClientsFailure,
  getAllClientsStart,
  ChangePasswordStart,
  ChangePasswordSuccess,
  ChangePasswordFailure

} = authSlice.actions;

export default authSlice.reducer;
